import React from 'react';

import { SearchableMultiSelect } from '@/components/ui/searchable-multi-select';
import { CALL_DIRECTION_FILTER_OPTIONS } from '@/pages/qc/utils';

interface CallDirectionFilterProps {
  selected: string[];
  onChange: (next: string[]) => void;
}

/** Call-direction multi-select shared by the analytics list and detail pages (AQ-841). */
export const CallDirectionFilter: React.FC<CallDirectionFilterProps> = ({ selected, onChange }) => (
  <SearchableMultiSelect
    options={CALL_DIRECTION_FILTER_OPTIONS}
    selected={selected}
    onChange={onChange}
    placeholder="All Directions"
    className="w-38 px-3"
    contentClassName="w-auto min-w-[180px]"
    searchPlaceholder="Search directions..."
    emptyMessage="No directions found."
  />
);
